import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export function OverstockCollect() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}
